export const Theme = {
  accentColor: "#e2441f",
  accentColorDarkBackground: "#ee6142",
  darkBackground: "#272A2D"
}